import { _getStorageWithExpiry } from '../utils/common.js';

export function gaSetUserProperties({ loginStatus, userType, sellerId }) {
  if (!window.gtag) return;

  window.gtag('set', 'user_properties', {
    login_status: loginStatus,
    user_type: userType,
    seller_id: sellerId || '(none)',
  });
}

export function gaEvent(name, params = {}) {
  if (!window.gtag) {
    console.warn('gtag is not defined');
    return;
  }

  window.gtag('event', name, params);
}

export function getUserContext() {
  const storedId = atob(_getStorageWithExpiry('id'));
  const storedSy = _getStorageWithExpiry('sy');
  const sellerId = _getStorageWithExpiry('sId');

  let sellerYn = '';
  try {
    sellerYn = storedSy ? atob(storedSy) : '';
  } catch (e) {
    sellerYn = '';
  }

  const loginStatus = storedId ? 'logged_in' : 'logged_out';
  const userType = sellerYn === 'Y' ? 'seller' : storedId ? 'member' : 'guest';

  return { loginStatus, userType, sellerId, storedId };
}

export function trackViewItemList(routePath) {
  const ctx = getUserContext();

  gaSetUserProperties(ctx);

  gaEvent('view_item_list', {
    page_name: 'product_list',
    seller_id: ctx.sellerId || null,
    login_status: ctx.loginStatus,
    user_type: ctx.userType,
  });
}
